/*
 * THTD — Cart events bridge (T2)
 * Makes every Udesly DRAWER-flow add/change observable as a Standard Storefront Event
 * WITHOUT editing the minified Udesly bundle. Wraps window.fetch and, on a successful
 * POST to /cart/add.js or /cart/change.js, dispatches shopify:cart:lines-update with a
 * promise that resolves to the resulting cart (and shopify:cart:error on failure).
 *
 * Hard safety contract (this touches the live cart):
 *   - capture the original fetch ONCE; always return the original Response untouched
 *   - NEVER throw out of the wrapper; NEVER read/consume the original response body
 *     (re-fetch /cart.js instead, via the shared memoized reader using the original fetch)
 *   - idempotent; only installs once the events lib is ready (else it never wraps at all)
 * Observability only: it adds events, it does not change cart behaviour or UI.
 *
 * Verified live (duplicate 182460383555): add → POST /cart/add.js (+ /cart/update.js,
 * which we intentionally ignore); the bundle issues /cart/change.js for drawer qty edits.
 * Loaded AFTER udesly-shopify.min.js.
 */
(function () {
  if (window.__thtd_cart_events) return;
  window.__thtd_cart_events = true;
  if (!(window.THTD && window.THTD.onSEReady)) return; // bootstrap missing → do nothing

  window.THTD.onSEReady(function (SE) {
    if (!SE || !SE.CartLinesUpdateEvent) return;
    var CLU = SE.CartLinesUpdateEvent;
    var orig = window.fetch;
    if (typeof orig !== 'function') return;

    function urlOf(args) {
      var a = args[0];
      if (a && typeof a === 'object' && a.url) return a.url; // Request object
      return String(a);
    }

    function parseBody(args) {
      try {
        var b = args[1] && args[1].body;
        if (typeof b === 'string') return JSON.parse(b);
      } catch (e) {}
      return null;
    }

    function linesForAdd(body) {
      try {
        if (body && Array.isArray(body.items)) {
          return body.items.map(function (it) {
            return { merchandiseId: String(it.id), quantity: Number(it.quantity != null ? it.quantity : 1) };
          });
        }
        if (body && body.id != null) return [{ merchandiseId: String(body.id), quantity: Number(body.quantity != null ? body.quantity : 1) }];
      } catch (e) {}
      return [];
    }

    function changeAction(body) {
      var qty = body && (body.quantity != null ? body.quantity : undefined);
      return { action: (Number(qty) === 0) ? 'remove' : 'update',
               lines: (body && (body.id != null || body.line != null))
                 ? [{ id: String(body.id != null ? body.id : body.line), quantity: Number(qty != null ? qty : 0) }]
                 : [] };
    }

    function errorCode(status) {
      if (status >= 500) return 'SERVICE_UNAVAILABLE';
      if (status === 429) return 'SERVICE_UNAVAILABLE';
      return 'INVALID'; // 4xx (sold out / invalid variant) — a valid CartErrorCode
    }

    window.fetch = function () {
      var args = arguments;
      var self = this;
      var url = '';
      try { url = urlOf(args); } catch (e) {}
      var isAdd = /\/cart\/add\.js(\?|$)/.test(url);
      var isChange = /\/cart\/change\.js(\?|$)/.test(url);
      var p = orig.apply(self, args);
      if (!isAdd && !isChange) return p; // fast path: untouched

      return p.then(function (res) {
        try {
          if (res && res.ok) {
            var body = parseBody(args);
            var action, lines, context;
            if (isAdd) { action = 'add'; lines = linesForAdd(body); context = 'product'; }
            else { var c = changeAction(body); action = c.action; lines = c.lines; context = 'dialog'; }

            window.THTD.cartJSON(orig).then(function (ajaxCart) {
              var cart;
              try { cart = CLU.createCartFromAjaxResponse ? CLU.createCartFromAjaxResponse(ajaxCart) : ajaxCart; }
              catch (e) { cart = ajaxCart; }
              var deferred = CLU.createPromise();
              var ev;
              try { ev = new CLU({ action: action, context: context, lines: lines, promise: deferred.promise }); }
              catch (e) { deferred.resolve({ cart: cart }); return; }
              document.dispatchEvent(ev);
              deferred.resolve({ cart: cart });
            }).catch(function () { /* cart re-fetch failed — emit nothing rather than a bad event */ });
          } else if (res) {
            try {
              if (SE.CartErrorEvent) {
                document.dispatchEvent(new SE.CartErrorEvent({ error: 'cart_mutation_failed', code: errorCode(res.status) }));
              }
            } catch (e) {}
          }
        } catch (e) { /* never break the cart */ }
        return res; // ALWAYS hand back the original, unread response
      });
    };
  });
})();
